













































































































































































import Vue from 'vue';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import servicoService from '../servico/servico-service';
import routerService from '../../base/router-service';
import planoService from './plano-service';
import usuarioService from '../usuario/usuario-service';
import { obterArquivosValidos } from '../../utils/utils';
import env from '../../env/env';
import { ArquivosSomentePdf } from '../../utils/constants';
import empresaAtualService from '../empresa-atual/empresa-atual-service';
import authService from '../../features/api-authorization/authorize-service';
import areaService from '../../features/area-atual/area-service';

@Component
export default class ChamadoInserirEditar extends Vue {
    plano: Api.App.Server.Plano.ObterPlano.Dto = null;

    areaAtual: string = null;

    empresaId: string = null;

    command: Api.App.Server.Plano.AlterarContratosPlano.Command = {
        contratoServico: null,
        contratoSocial: null,
    };

    linkDownloadContratoServico = '';

    linkDownloadContratoSocial = '';

    perfilUsuario: Api.Common.Infra.Auth.PerfilTipoUsuarioEnum = null;

    PerfilUsuarioEnum = Api.Common.Infra.Auth.PerfilTipoUsuarioEnum;

    linkServicoUpPlanoId = '';

    rules = {
        $summary: [] as any[],
    };

    abrirMeuPlano() {
        routerService.goTo('plano-detalhe');
    }

    abrirMinhaFormaDePagamento() {
        routerService.goTo('forma-pagamento-inserir-editar');
    }

    tipoArquivos = ArquivosSomentePdf;

    async obterPerfilUsuario() {
        this.perfilUsuario = await usuarioService.obterPerfilUsuario({});
    }

    async obterPlano() {
        var email = await authService.getUser();

        this.plano = await planoService.obterPlano({
            empresaId: this.empresaId,
            email: email.name
        });

        if (this.plano.caminhoContratoServico)
            this.linkDownloadContratoServico = `${env.apiUrl}/api/Plano/BaixarArquivo?tipoContrato=${Api.App.Server.Plano.ObterCaminhoArquivo.TipoContratoEnum.Servico}`;

        if (this.plano.caminhoContratoSocial)
            this.linkDownloadContratoSocial = `${env.apiUrl}/api/Plano/BaixarArquivo?tipoContrato=${Api.App.Server.Plano.ObterCaminhoArquivo.TipoContratoEnum.Social}`;
    }

    selecionarContratoServico() {
        if (this.$refs.anexoContratoServico)
            (this.$refs.anexoContratoServico as any).click();
    }

    selecionarContratoSocial() {
        if (this.$refs.anexoContratoSocial)
            (this.$refs.anexoContratoSocial as any).click();
    }

    salvarAlteracoes() {
        let formData = new FormData();

        formData.append('contratoServico', this.command.contratoServico);

        formData.append('contratoSocial', this.command.contratoSocial);

        formData.append('empresaId', this.empresaId);

        this.$action.processSubmit({
            action: async () => {
                await planoService.alterarContratosPlano(formData);

                await this.obterPlano();
            },
            form: this.$refs.form,
            rules: this.rules,
        });
    }

    async removerAnexoContratoServico() {
        this.$action.processSubmit({
            action: async () => {
                await planoService.removerContratos({
                    removerContratoServico: true,
                    removerContratoSocial: false,
                    empresaId: this.empresaId,
                });

                await this.obterPlano();
            },
            form: this.$refs.form,
            rules: this.rules,
        });
    }

    async removerAnexoContratoSocial() {
        this.$action.processSubmit({
            action: async () => {
                await planoService.removerContratos({
                    removerContratoServico: false,
                    removerContratoSocial: true,
                    empresaId: this.empresaId,
                });

                await this.obterPlano();
            },
            form: this.$refs.form,
            rules: this.rules,
        });
    }

    async anexoContratoServicoChange(event) {
        let file = event.target.files;

        let arquivo = obterArquivosValidos(file, this.tipoArquivos);

        if (arquivo && arquivo.length > 0) {
            this.command.contratoServico = arquivo[0];

            await this.salvarAlteracoes();
        }
    }

    async anexoContratoSocialChange(event) {
        let file = event.target.files;

        let arquivo = obterArquivosValidos(file, this.tipoArquivos);

        if (arquivo && arquivo.length > 0) {
            this.command.contratoSocial = arquivo[0];

            await this.salvarAlteracoes();
        }
    }

    async obterServicoUpPlanoId() {
        let servicoId: any = await servicoService.obterServicoUpPlanoId({});
        this.linkServicoUpPlanoId = `${env.appUrl}/chamado/registrar/${servicoId.servicoGrupoId}/${servicoId.id}`;
    }

    async logout() {
        if (this.empresaId == null) {
            await authService.signOut({ returnUrl: location.origin });
        }
    }

    async carregarDados() {
        this.obterServicoUpPlanoId();
        this.obterPerfilUsuario();
        this.obterPlano();
    }

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();
        if (this.empresaId != null) {
            this.carregarDados();
        }
    }
}
